export default __webpack_public_path__ + "images/KTB.f3eaa7f.png";